import Checkbox from "../../../../checkbox";
import styles from "./styles.module.css";
export default function Transition({ condition, onChange }) {
  const handleChange = (v) => {
    const _condition = { ...condition };
    _condition.transition = v;
    onChange(_condition);
  };
  return (
    <div style={{ display: "flex", alignItems: "center", marginTop: 12 }}>
      <Checkbox checked={condition.transition} onChange={handleChange} />
      <div style={{ margin: 0, marginLeft: 6 }} className={styles.propTitle}>
        Apply Transition
      </div>
    </div>
  );
}
